module.exports = __webpack_public_path__ + "static/media/desktopAndMobileMockup.ce67cfa1.png";